import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const cities = [
  'Oklahoma City', 'Edmond', 'Norman', 'Moore', 'Yukon', 'Mustang',
  'Midwest City', 'Del City', 'Bethany', 'Warr Acres', 'Nichols Hills', 'Choctaw'
];

export default function ServiceArea() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="py-16 lg:py-24 bg-gray-900">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className={isVisible ? 'lg:animate-fade-up' : 'lg:opacity-0'}>
            <p className="text-yellow-400 uppercase tracking-wider text-sm font-semibold mb-4">
              Serving the OKC Metro
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-[1.05]" style={{ fontFamily: 'Oswald, sans-serif' }}>
              Professional Service Across Oklahoma City
            </h2>
            <p className="text-gray-300 text-lg leading-[1.45] mb-8">
              Sooner Blacktop proudly serves commercial properties throughout the Oklahoma City metropolitan area, including:
            </p>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {cities.map((city, index) => (
                <div key={index} className="flex items-center text-gray-300">
                  <i className="ri-map-pin-line text-yellow-400 mr-2"></i>
                  <span>{city}</span>
                </div>
              ))}
            </div>
            <Link
              to="/service-areas"
              className="inline-flex items-center text-yellow-400 font-semibold hover:text-yellow-300 transition-colors cursor-pointer"
            >
              View All Service Areas
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          <div className={`relative ${isVisible ? 'lg:animate-fade-in' : 'lg:opacity-0'}`}>
            <div className="bg-gray-800 rounded-2xl p-6 lg:p-7 relative overflow-hidden">
              <div className="w-full h-[500px] rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d416087.3586654469!2d-97.74316844999999!3d35.467560349999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b217a4cda8af93%3A0x70b9f3d7b0c3c5e!2sOklahoma%20City%2C%20OK!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Oklahoma City Metro Service Area"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
